import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import NewsletterForm from '@/components/feature/NewsletterForm';
import SEOSchema from '@/components/feature/SEOSchema';
import { articles } from '@/mocks/articles';

export default function ArticlesPage() {
  return (
    <>
      <ScrollToTop />
      <SEOSchema type="WebPage" data={{
        name: '精选文章 | 久久精品',
        description: '久久精品精选文章，分享品质生活灵感、好物推荐、家居设计、时尚趋势等精彩内容。',
        inLanguage: 'zh-CN',
        isPartOf: { '@type': 'WebSite', name: '久久精品', url: 'https://jiujiuboutique.com' },
      }} />
      <SEOSchema type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://jiujiuboutique.com/' },
          { '@type': 'ListItem', position: 2, name: '精选文章', item: 'https://jiujiuboutique.com/articles' },
        ],
      }} />

      <Navbar />
      <main className="min-h-screen pt-20">
        <Breadcrumb items={[{ label: '精选文章' }]} />

        <section className="w-full py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
                精选文章
              </h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
                品质生活灵感，从阅读开始。久久精品为你精选好文，发现更美好的生活方式。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {articles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        <NewsletterForm />
      </main>
      <Footer />
    </>
  );
}